import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ContentResourceType } from './Enums'
/**
* Class ShowcaseContentResourceDto
*  Приложенный к материалу файл витрины: элемент галереи или документ
*/
export class ShowcaseContentResourceDto extends ActiveModel {

/**
  * resourceId
  * Идентификатор файла-ресурса. Domain.Entities.Resources.Resource.Id
  */
  @ActiveField('')
  resourceId: string = ''


  /**
  * type
  * Тип файла-ресурса контента  *   * - `Image` Изображение  *   * Изображение (галерея)  * - `Document` Документ  *   * Документ (PDF-инструкции и пр.)  *   */
  @ActiveField(ContentResourceType.IMAGE)
  type: ContentResourceType = ContentResourceType.IMAGE


/**
  * displayName
  * Отображаемое имя («Инструкция.pdf»)<br>
  */
  @ActiveField()
  displayName?: null | string


  /**
  * order
  *   */
  @ActiveField(0)
  order: number = 0
}
